module.exports = __webpack_public_path__ + "img/11-1_07.e4c38b98.jpg";